import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const AttendanceLazy = React.lazy(
	() =>
		import(/* webpackChunkName : 'StudentProfileAttendance' */ './components')
);

export default () => ({
	path: 'attendance',
	element: <AsyncLoading component={<AttendanceLazy />} />,
});
